import { Form, Input } from 'antd';
import Box from 'components/Box';
import Text from 'components/Text';
import styled from 'styled-components';
import SwitchBtn from '../ServicesSettingV2/SwitchBtn';
import HTMLEditor from '../PaymentTabMenu/ConsentForm/HtmlEditor';
import settingApis from 'features/settingService/services/apis';
import { useEffect, useState } from 'react';
import { IResponseDataBody } from 'services/response';
import { IBodyNotificationSettingPut } from 'features/settingService/services/types/generalSetting';
import toast from 'utils/toast';
import settingServiceSelectors from 'features/settingService/services/selectors';
import { useAppDispatch } from 'store/hooks';
import settingServiceActions from 'features/settingService/services/actions';
import { get } from 'lodash';
import { useSetLoadingPage } from 'services/UI/LoadingPage';

const NotificationSetting = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const setLoading = useSetLoadingPage();
  const notificationSettingConfig = settingServiceSelectors.getNotificationSettingConfig();
  const [initialValues, setInitialValues] = useState<IBodyNotificationSettingPut>();

  const onFinish = async (values: IBodyNotificationSettingPut) => {
    try {
      setLoading(true);
      const res: IResponseDataBody<any> = await settingApis.updateNotificationSetting(values);
      if (res.data.data) {
        toast.success('Notification setting updated successfully');
      } else {
        toast.error('Failed to update notification setting');
      }
    } catch (error) {
      const msg = get(error, 'response.data.message');
      toast.error(msg || 'Failed to update notification setting');
    } finally {
      setLoading(false);
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  const onDone = () => {
    form.submit();
  };

  useEffect(() => {
    dispatch(settingServiceActions.getNotificationSetting.fetch());
  }, []);

  useEffect(() => {
    if (notificationSettingConfig) {
      setInitialValues(notificationSettingConfig);
      form.setFieldsValue(notificationSettingConfig);
    }
  }, [notificationSettingConfig]);
  return (
    <Wrrapper>
      <Container>
        <Form form={form} layout='vertical' onFinish={onFinish} initialValues={initialValues}>
          <Box display='flex' gap='3' flexDirection='column'>
            <Box display='flex' gap='3' alignItems='center'>
              <Form.Item name='enable'>
                <SwitchBtn />
              </Form.Item>
              <Text variant='H5' color='text_3'>
                Show Notification
              </Text>
            </Box>

            <Form.Item name='title' label='Title'>
              <Input.TextArea
                rows={4}
                placeholder='Please enter ...'
                style={{ fontSize: '24px' }}
              />
            </Form.Item>

            <Form.Item name='description' label='Content'>
              <HTMLEditor />
            </Form.Item>
          </Box>
        </Form>
      </Container>
      <StickyFooter>
        <ButtonFooter className='btn-reset' type='button' onClick={onReset}>
          Reset
        </ButtonFooter>
        <ButtonFooter className='btn-save' type='button' onClick={onDone}>
          Save
        </ButtonFooter>
      </StickyFooter>
    </Wrrapper>
  );
};

export default NotificationSetting;

const Wrrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const Container = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  .ant-form-item {
    margin-bottom: 0;
  }

  .ant-form-item-label label {
    color: #1d2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const StickyFooter = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  align-items: center;
  background: var(--Neutral-03, #f5f5f5);
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.15);
  padding: 16px;
`;

const ButtonFooter = styled.button`
  display: flex;
  width: 208px;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #e5e6eb;
  box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4), 0px 4px 8px -3px rgba(45, 35, 66, 0.3),
    0px -3px 0px 0px #d6d6e7 inset;
  color: #1d2129;
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &.btn-save {
    background: #ff8890;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.4), 0px 4px 8px -3px rgba(45, 35, 66, 0.3),
      0px -4px 0px 0px #e7646d inset;
    color: #fff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
